module.exports = __webpack_public_path__ + "fonts/234bf5aed7380ed1d3c766c7618d8775.eot";